import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const DialogHeadingWrapper = styled.div`
    padding: ${token('space.400', '24px')} ${token('space.400', '24px')} ${token('space.200', '16px')} 0;
`;

export const DialogContentWrapper = styled.div`
    color: ${token('color.text.subtle', colors.N200)};
`;

export const RemoveHelpDeskWrapper = styled.div`
    padding: ${token('space.200', '16px')} 0;
    margin-top: ${token('space.500', '40px')};
    border-top: solid 2px ${token('color.border', colors.N40)};
    border-radius: ${token('border.radius.300', '3px')};
    color: ${token('color.text.subtlest', '#626F86')};

    p {
        margin-bottom: ${token('space.300', '24px')};
    }

    & h3 {
        color: ${token('color.text.subtle', '#44546F')};
    }
`;
